import React, { useRef, useEffect, useState } from 'react';
import BookCharts from './BookCharts';
import FeatherIcon from 'feather-icons-react';

const ReportBook = ({ reportData }) => {
  const [toc, setToc] = useState([]);
  const tocRef = useRef([]);

  useEffect(() => {
    // Collect TOC data after first render
    if (reportData) {
      const table = [];
      Object.keys(reportData).forEach((category) => {
        table.push({ type: 'category', name: `${category}` });

        reportData[category].forEach((report) => {
          table.push({
            type: 'form',
            name: `${report.form_serial}. ${report.form_name}`,
          });
        });
      });
      setToc(table);
    }
  }, [reportData]);

  console.log('reportData:', reportData);

  const renderFilteringDescription = (param) => (
    <div key={param.name}>
      <strong>{param.label || param.name}</strong> ({param.type})
    </div>
  );

  const renderParametersForm = (params) =>
    params.map((param) => (
      <div key={param.name} style={{ marginBottom: '0rem' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '0px' }}>
            {param.label || param.name}
            {param.is_required && (
              <span style={{ color: 'red', marginLeft: '0px' }}>*</span>
            )}
          </label>
          <input
            type="text"
            disabled
            value={`Type: ${param.type}`}
            style={{ display: 'block', width: '100%' }}
          />
        </div>
      </div>
    ));

  const renderParameters = (params) => (
    <table
      style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}
    >
      <thead>
        <tr>
          <th style={{ border: '1px solid #ccc', padding: '8px' }}>
            Field Name
          </th>
          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Type</th>
          <th style={{ border: '1px solid #ccc', padding: '8px' }}>Required</th>
        </tr>
      </thead>
      <tbody>
        {params.map((param) => (
          <tr key={param.name}>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
              <strong>{param.label || param.name}</strong>
            </td>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
              {param.type}
            </td>
            <td style={{ border: '1px solid #ccc', padding: '8px' }}>
              {param.is_required ? (
                <span style={{ color: 'red' }}>Required *</span>
              ) : (
                'Optional'
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div style={styles.page}>
      {/* Cover Page
      <div style={styles.coverPage}>
        <img src="/logo.png" alt="Logo" style={styles.logo} />
        <h1>System Report</h1>
        <h3>Version 1.0</h3>
        <p>Author: Your Name</p>
      </div> */}
      {/* Table of Contents */}

      {/* Table of Contents */}
      <div style={styles.tocPage}>
        <h1 style={styles.tocTitle}>Table of Contents</h1>
        <div style={styles.tocBox}>
          <ul style={styles.tocList}>
            {toc.map((item, idx) => (
              <li
                key={idx}
                style={{
                  fontWeight: item.type === 'category' ? 'bold' : 'normal',
                  marginLeft: item.type === 'form' ? '30px' : '0px',
                  marginBottom: '10px',
                }}
              >
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* <BookCharts /> */}

      {/* Actual Content */}
      {/* {reportData &&
        Object.keys(reportData).map((category) => (
          <div key={category} style={styles.section}>
            <h2>{category}</h2>
            <p>{reportData[category][0].category_description}</p>
            <h4>Features:</h4>
            <ul>
              {reportData[category].map((report, index) => (
                <li key={index}>
                  {report.form_serial}. {report.form_name}
                </li>
              ))}
            </ul>

            {reportData[category].map((report, index) => {
              report.parameters = report.parameters.filter(
                (param) =>
                  param.name !== 'to' &&
                  param.type !== 'hidden' &&
                  param.type !== 'hidden-user'
              );

              return (
                <div key={index} style={styles.reportBlock}>
                  <h3>
                    {report.form_serial}. {report.form_name}
                  </h3>
                  <p>{report.description}</p>

                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') && (
                    <>
                      <h4>Report Columns:</h4>
                      <table style={styles.table}>
                        <thead>
                          <tr>
                            {report.fields ? (
                              report.fields.split(',').map((field, idx) => (
                                <th key={idx} style={styles.cell}>
                                  {field.replace(/`/g, '')}
                                </th>
                              ))
                            ) : (
                              <th>No fields found</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {report.fields ? (
                              report.fields.split(',').map((_, idx) => (
                                <td key={idx} style={styles.cell}>
                                  -
                                </td>
                              ))
                            ) : (
                              <td>No data</td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') &&
                    report.parameters.length > 0 && (
                      <>
                        <h4>Filtering Options:</h4>
                        <div>
                          {report.parameters.map(renderFilteringDescription)}
                        </div>
                      </>
                    )}

                  {(report.form_type === 'reg-modal' ||
                    report.form_type === 'reg-upload-modal') && (
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <div style={{ flex: 1 }}>
                        <h4>Form:</h4>
                        {renderParametersForm(report.parameters)}
                      </div>
                      <div style={{ flex: 2 }}>
                        <h4>Form Fields:</h4>
                        {renderParameters(report.parameters)}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))} */}
      {reportData &&
        Object.keys(reportData).map((category) => (
          <div key={category} style={styles.section}>
            <h2>{category}</h2>
            <p>{reportData[category][0].category_description}</p>
            <h4>Features:</h4>
            <ul>
              {reportData[category].map((report, index) => (
                <li key={index}>
                  {report.form_serial}. {report.form_name}
                </li>
              ))}
            </ul>

            {category === 'Dashboard charts' && (
              <div className="row">
                {reportData[category] &&
                  reportData[category].length > 0 &&
                  reportData[category].map((report, index) => {
                    const chartIcon = report.fields?.split(',')[0];
                    const chartColor = report.fields?.split(',')[1];
                    return (
                      <div
                        className="col-12 col-sm-6 col-md-6 mb-6"
                        key={index}
                      >
                        <div
                          className={`card text-white bg-${chartColor} h-100`}
                        >
                          <div className="card-body d-flex flex-column">
                            <FeatherIcon icon={chartIcon} />
                            <h4 className="card-title mt-3">
                              {report.form_name}
                            </h4>
                            <p className="card-text h5">
                              {Math.floor(Math.random() * 1000) + 100}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}

            {/* Render each report */}
            {reportData[category].map((report, index) => {
              report.parameters = report.parameters.filter(
                (param) =>
                  param.name !== 'to' &&
                  param.type !== 'hidden' &&
                  param.type !== 'hidden-user'
              );

              return (
                <div key={index} style={styles.reportBlock}>
                  <h3>
                    {report.form_serial}. {report.form_name}
                  </h3>
                  <p>{report.description}</p>

                  {/* REPORT BLOCK */}
                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') && (
                    <>
                      <h4>Report Columns:</h4>
                      <table style={styles.table}>
                        <thead>
                          <tr>
                            {report.fields ? (
                              report.fields.split(',').map((field, idx) => (
                                <th key={idx} style={styles.cell}>
                                  {field.replace(/`/g, '')}
                                </th>
                              ))
                            ) : (
                              <th>No fields found</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {report.fields ? (
                              report.fields.split(',').map((_, idx) => (
                                <td key={idx} style={styles.cell}>
                                  -
                                </td>
                              ))
                            ) : (
                              <td>No data</td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )}

                  {(report.form_type === 'report' ||
                    report.form_type === 'form-report') &&
                    report.parameters.length > 0 && (
                      <>
                        <h4>Filtering Options:</h4>
                        <div>
                          {report.parameters.map(renderFilteringDescription)}
                        </div>
                      </>
                    )}

                  {(report.form_type === 'reg-modal' ||
                    report.form_type === 'reg-upload-modal') && (
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <div style={{ flex: 1 }}>
                        <h4>Form:</h4>
                        {renderParametersForm(report.parameters)}
                      </div>
                      <div style={{ flex: 2 }}>
                        <h4>Form Fields:</h4>
                        {renderParameters(report.parameters)}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
    </div>
  );
};

const styles = {
  tocPage: {
    width: '794px', // A4
    height: '1123px',
    margin: '0 auto',
    pageBreakAfter: 'always',
    padding: '60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    border: '3px solid #000',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },

  tocTitle: {
    textAlign: 'center',
    fontSize: '32px',
    marginBottom: '40px',
    textDecoration: 'underline',
  },

  tocBox: {
    padding: '30px',
    border: '2px dashed #333',
    height: '100%',
    overflow: 'hidden',
  },

  tocList: {
    listStyleType: 'none',
    paddingLeft: 0,
    fontSize: '18px',
    lineHeight: '1.8',
  },

  section: {
    pageBreakBefore: 'always',
    marginBottom: '60px',
    paddingBottom: '20px',
    borderBottom: '1px dashed #999',
    width: '794px',
    margin: '0 auto',
    padding: '40px',
    boxSizing: 'border-box',
  },
  reportBlock: {
    breakInside: 'avoid',
    border: '1px solid #ccc',
    padding: '20px',
    marginTop: '20px',
    marginBottom: '40px',
    borderRadius: '8px',
    backgroundColor: '#fefefe',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
    marginBottom: '20px',
  },
  cell: {
    border: '1px solid black',
    padding: '3px',
  },
};

export default ReportBook;
